(function () {
  var COLORS = { blue: '#29759c', orange: '#ef6b1a', ink: '#000000', grid: '#b7c6ce', soft: '#f2f5f7' };
  var FACET_LABELS = {
    geometry: 'Geometry / Type', material: 'Material', wavelength: 'Wavelength Band', coating: 'Coating',
    size: 'Diameter / Size Range', focal: 'Focal Length Range', power: 'Optical Power', grade: 'Performance Grade',
    ratio: 'Split Ratio', bandwidth: 'Filter Bandwidth', density: 'Optical Density', retardance: 'Retardance',
    grooves: 'Groove Density (lines/mm)', pattern: 'Pattern Type', availability: 'Availability'
  };
  var FILTER_PROFILES = {
    lens: ['geometry', 'material', 'wavelength', 'focal', 'size', 'power', 'coating', 'grade', 'availability'],
    window: ['geometry', 'material', 'wavelength', 'size', 'grade', 'coating', 'availability'],
    prism: ['geometry', 'material', 'wavelength', 'size', 'grade', 'coating', 'availability'],
    mirror: ['geometry', 'coating', 'wavelength', 'focal', 'size', 'material', 'grade', 'availability'],
    beamsplitter: ['geometry', 'ratio', 'wavelength', 'material', 'coating', 'grade', 'availability'],
    filter: ['geometry', 'wavelength', 'bandwidth', 'density', 'size', 'material', 'grade', 'availability'],
    polarization: ['geometry', 'retardance', 'wavelength', 'size', 'material', 'coating', 'availability'],
    grating: ['geometry', 'grooves', 'wavelength', 'material', 'availability'],
    reticle: ['pattern', 'size', 'material', 'availability'],
    generic: ['geometry', 'material', 'wavelength', 'size', 'coating', 'availability']
  };

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }

  function cardValues(card, key) {
    if (key === 'availability') return [card.getAttribute('data-available') === 'true' ? 'In Stock' : 'Out of Stock'];
    return (card.getAttribute('data-filter-' + key) || '').split('||').map(function (value) { return value.trim(); }).filter(Boolean);
  }

  function line(ctx, x1, y1, x2, y2, color, width, dash) {
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.strokeStyle = color || COLORS.ink;
    ctx.lineWidth = width || 2;
    if (dash) ctx.setLineDash(dash);
    ctx.stroke();
    ctx.restore();
  }

  function path(ctx, points, color, width, close, fill) {
    ctx.save();
    ctx.beginPath();
    points.forEach(function (point, index) {
      if (index === 0) ctx.moveTo(point[0], point[1]);
      else ctx.lineTo(point[0], point[1]);
    });
    if (close) ctx.closePath();
    if (fill) {
      ctx.fillStyle = fill;
      ctx.fill();
    }
    ctx.strokeStyle = color || COLORS.ink;
    ctx.lineWidth = width || 2;
    ctx.stroke();
    ctx.restore();
  }

  function arrow(ctx, x1, y1, x2, y2, color) {
    var angle = Math.atan2(y2 - y1, x2 - x1);
    line(ctx, x1, y1, x2, y2, color, 3);
    ctx.save();
    ctx.translate(x2, y2);
    ctx.rotate(angle);
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(-11, -5);
    ctx.lineTo(-11, 5);
    ctx.closePath();
    ctx.fillStyle = color;
    ctx.fill();
    ctx.restore();
  }

  function label(ctx, text, x, y, color, size, align) {
    ctx.save();
    ctx.fillStyle = color || COLORS.ink;
    ctx.font = '700 ' + (size || 12) + 'px Arial, sans-serif';
    ctx.textAlign = align || 'left';
    ctx.textBaseline = 'middle';
    ctx.fillText(text, x, y);
    ctx.restore();
  }

  function note(ctx, text) {
    label(ctx, text, 28, 329, '#53616d', 10);
    label(ctx, 'TYPICAL PRINCIPLE · NOT TO SCALE', 732, 329, COLORS.blue, 10, 'right');
  }

  function drawLens(ctx) {
    [115, 180, 245].forEach(function (y) { arrow(ctx, 36, y, 307, y, COLORS.blue); });
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(350, 66);
    ctx.bezierCurveTo(425, 102, 425, 258, 350, 294);
    ctx.bezierCurveTo(334, 245, 334, 115, 350, 66);
    ctx.closePath();
    ctx.fillStyle = 'rgba(41,117,156,.16)';
    ctx.strokeStyle = COLORS.ink;
    ctx.lineWidth = 3;
    ctx.fill();
    ctx.stroke();
    ctx.restore();
    [115, 180, 245].forEach(function (y) { arrow(ctx, 385, y, 610, 180, COLORS.orange); });
    line(ctx, 610, 70, 610, 292, COLORS.grid, 1, [6, 6]);
    label(ctx, 'POSITIVE LENS', 350, 42, COLORS.ink, 12, 'center');
    label(ctx, 'FOCAL PLANE', 610, 48, COLORS.orange, 11, 'center');
    note(ctx, 'Converging rays define positive focal power and working distance.');
  }

  function drawWindow(ctx) {
    [112, 180, 248].forEach(function (y) { arrow(ctx, 42, y, 285, y - 18, COLORS.blue); });
    path(ctx, [[300, 66], [365, 66], [455, 292], [390, 292]], COLORS.ink, 3, true, 'rgba(41,117,156,.15)');
    [94, 162, 230].forEach(function (y) { arrow(ctx, 403, y + 42, 708, y + 24, COLORS.orange); });
    line(ctx, 333, 52, 423, 306, COLORS.grid, 1, [6, 6]);
    label(ctx, 'PRECISION WINDOW', 378, 40, COLORS.ink, 12, 'center');
    label(ctx, 'PARALLEL OR WEDGED FACES', 378, 316, COLORS.blue, 10, 'center');
    note(ctx, 'Material, thickness, flatness and wedge control transmitted wavefront.');
  }

  function drawPrism(ctx) {
    path(ctx, [[285, 278], [475, 278], [380, 80]], COLORS.ink, 3, true, 'rgba(41,117,156,.14)');
    arrow(ctx, 45, 200, 318, 200, COLORS.blue);
    arrow(ctx, 318, 200, 432, 170, COLORS.orange);
    arrow(ctx, 432, 170, 626, 56, COLORS.orange);
    line(ctx, 380, 80, 380, 278, COLORS.grid, 1, [6, 6]);
    label(ctx, 'BEAM DEVIATION', 644, 50, COLORS.orange, 11);
    label(ctx, 'APEX ANGLE', 380, 304, COLORS.blue, 10, 'center');
    note(ctx, 'Prism geometry controls deviation, dispersion, image orientation or return path.');
  }

  function drawMirror(ctx) {
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(500, 72);
    ctx.quadraticCurveTo(390, 180, 500, 288);
    ctx.strokeStyle = COLORS.ink;
    ctx.lineWidth = 5;
    ctx.stroke();
    ctx.restore();
    [115, 180, 245].forEach(function (y) { arrow(ctx, 45, y, 454, y, COLORS.blue); });
    arrow(ctx, 454, 115, 275, 180, COLORS.orange);
    arrow(ctx, 454, 180, 275, 180, COLORS.orange);
    arrow(ctx, 454, 245, 275, 180, COLORS.orange);
    ctx.beginPath();
    ctx.arc(275, 180, 5, 0, Math.PI * 2);
    ctx.fillStyle = COLORS.orange;
    ctx.fill();
    label(ctx, 'REFLECTIVE SURFACE', 516, 180, COLORS.ink, 11);
    label(ctx, 'FOCUS', 275, 207, COLORS.orange, 10, 'center');
    note(ctx, 'Geometry defines beam folding or focusing; coating defines spectral response.');
  }

  function drawBeamsplitter(ctx) {
    path(ctx, [[330, 64], [370, 64], [468, 296], [428, 296]], COLORS.ink, 3, true, 'rgba(41,117,156,.15)');
    arrow(ctx, 40, 180, 379, 180, COLORS.blue);
    arrow(ctx, 379, 180, 708, 180, COLORS.orange);
    arrow(ctx, 379, 180, 379, 48, COLORS.orange);
    label(ctx, 'TRANSMITTED', 704, 158, COLORS.orange, 10, 'right');
    label(ctx, 'REFLECTED', 394, 48, COLORS.orange, 10);
    label(ctx, 'COATED INTERFACE', 410, 313, COLORS.blue, 10, 'center');
    note(ctx, 'Plate, wedge and cube formats divide power by ratio and polarization state.');
  }

  function drawFilter(ctx) {
    line(ctx, 92, 280, 690, 280, COLORS.ink, 2);
    line(ctx, 92, 280, 92, 64, COLORS.ink, 2);
    for (var x = 180; x <= 620; x += 110) line(ctx, x, 280, x, 72, COLORS.grid, 1);
    for (var y = 100; y <= 240; y += 47) line(ctx, 92, y, 690, y, COLORS.grid, 1);
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(95, 270);
    ctx.bezierCurveTo(260, 268, 285, 256, 320, 100);
    ctx.bezierCurveTo(330, 78, 452, 78, 462, 100);
    ctx.bezierCurveTo(497, 256, 522, 268, 686, 270);
    ctx.strokeStyle = COLORS.blue;
    ctx.lineWidth = 5;
    ctx.stroke();
    ctx.restore();
    line(ctx, 391, 82, 391, 280, COLORS.orange, 2, [6, 5]);
    label(ctx, 'TRANSMISSION', 35, 170, COLORS.ink, 11, 'center');
    label(ctx, 'WAVELENGTH', 690, 310, COLORS.ink, 11, 'right');
    label(ctx, 'CENTER WAVELENGTH', 391, 55, COLORS.orange, 10, 'center');
    note(ctx, 'Passband, edge position, blocking and optical density determine spectral control.');
  }

  function drawPolarization(ctx) {
    ctx.save();
    ctx.beginPath();
    ctx.arc(370, 180, 102, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(41,117,156,.12)';
    ctx.fill();
    ctx.strokeStyle = COLORS.ink;
    ctx.lineWidth = 3;
    ctx.stroke();
    ctx.restore();
    for (var i = -64; i <= 64; i += 18) line(ctx, 305 + i, 245, 435 + i, 115, COLORS.grid, 1);
    arrow(ctx, 40, 180, 268, 180, COLORS.blue);
    arrow(ctx, 472, 180, 708, 180, COLORS.orange);
    line(ctx, 530, 115, 530, 245, COLORS.orange, 3);
    label(ctx, 'POLARIZATION AXIS', 546, 108, COLORS.orange, 10);
    label(ctx, 'POLARIZER / RETARDER', 370, 55, COLORS.ink, 12, 'center');
    note(ctx, 'Axis orientation and retardance are selected for wavelength and polarization state.');
  }

  function drawGrating(ctx) {
    path(ctx, [[305, 76], [445, 76], [445, 284], [305, 284]], COLORS.ink, 3, true, 'rgba(41,117,156,.12)');
    for (var x = 316; x < 445; x += 11) line(ctx, x, 78, x, 282, COLORS.blue, 1);
    arrow(ctx, 55, 260, 337, 190, COLORS.ink);
    arrow(ctx, 337, 190, 665, 72, COLORS.orange);
    arrow(ctx, 337, 190, 690, 168, COLORS.blue);
    arrow(ctx, 337, 190, 650, 270, COLORS.orange);
    label(ctx, 'DIFFRACTED ORDERS', 650, 46, COLORS.ink, 11, 'center');
    label(ctx, 'GROOVE DIRECTION', 375, 308, COLORS.blue, 10, 'center');
    note(ctx, 'Groove density, blaze and operating order determine angular dispersion and efficiency.');
  }

  function drawReticle(ctx) {
    ctx.save();
    ctx.beginPath();
    ctx.arc(380, 180, 120, 0, Math.PI * 2);
    ctx.fillStyle = '#ffffff';
    ctx.fill();
    ctx.strokeStyle = COLORS.ink;
    ctx.lineWidth = 3;
    ctx.stroke();
    ctx.restore();
    line(ctx, 220, 180, 540, 180, COLORS.blue, 2);
    line(ctx, 380, 42, 380, 318, COLORS.blue, 2);
    [38, 72].forEach(function (r) {
      ctx.beginPath();
      ctx.arc(380, 180, r, 0, Math.PI * 2);
      ctx.strokeStyle = COLORS.orange;
      ctx.lineWidth = 2;
      ctx.stroke();
    });
    for (var i = -5; i <= 5; i += 1) {
      var tick = i % 5 === 0 ? 13 : 7;
      line(ctx, 380 + i * 18, 180 - tick, 380 + i * 18, 180 + tick, COLORS.ink, 1);
      line(ctx, 380 - tick, 180 + i * 18, 380 + tick, 180 + i * 18, COLORS.ink, 1);
    }
    label(ctx, 'REFERENCE PATTERN', 380, 32, COLORS.ink, 12, 'center');
    note(ctx, 'Pattern geometry, pitch, line width and substrate accuracy define the calibration task.');
  }

  function drawCategoryDiagram(canvas) {
    var handle = canvas.getAttribute('data-category') || '';
    var width = 760;
    var height = 360;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = width * dpr;
    canvas.height = height * dpr;
    var ctx = canvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = COLORS.soft;
    ctx.fillRect(0, 0, width, height);
    if (handle.indexOf('windows') > -1) drawWindow(ctx);
    else if (handle.indexOf('prism') > -1) drawPrism(ctx);
    else if (handle.indexOf('mirror') > -1) drawMirror(ctx);
    else if (handle.indexOf('beamsplitter') > -1) drawBeamsplitter(ctx);
    else if (handle.indexOf('filter') > -1) drawFilter(ctx);
    else if (handle.indexOf('polarization') > -1) drawPolarization(ctx);
    else if (handle.indexOf('grating') > -1) drawGrating(ctx);
    else if (handle.indexOf('reticle') > -1 || handle.indexOf('calibration') > -1) drawReticle(ctx);
    else drawLens(ctx);
  }

  function init(root) {
    var toggle = root.querySelector('.gsc-filter-toggle');
    var filters = root.querySelector('.gsc-filters');
    var search = root.querySelector('[data-gsc-search]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-gsc-product]'));
    var empty = root.querySelector('[data-gsc-empty]');
    var facetGroups = root.querySelector('[data-gsc-facet-groups]');
    var clearButton = root.querySelector('[data-gsc-clear]');
    var priceGroup = root.querySelector('[data-gsc-price-group]');
    var priceMinInput = root.querySelector('[data-gsc-price-min]');
    var priceMaxInput = root.querySelector('[data-gsc-price-max]');
    var priceApply = root.querySelector('[data-gsc-price-apply]');
    var visibleCount = root.querySelector('.gsc-toolbar > span');
    var headingCount = root.querySelector('.gsc-browser-count strong');
    var profile = root.getAttribute('data-gsc-filter-profile') || 'generic';
    var profileKeys = FILTER_PROFILES[profile] || FILTER_PROFILES.generic;
    var selected = {};
    var priceMin = '';
    var priceMax = '';

    if (toggle && filters) {
      toggle.addEventListener('click', function () {
        var open = filters.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
      });
    }

    function optionsFor(key) {
      var values = [];
      cards.forEach(function (card) { values = values.concat(cardValues(card, key)); });
      return Array.from(new Set(values)).sort(function (a, b) {
        return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
      });
    }

    function renderFacets() {
      if (!facetGroups) return;
      var html = '';
      profileKeys.forEach(function (key, index) {
        var options = optionsFor(key);
        if (options.length < 2) return;
        html += '<details class="gsc-filter-group" data-gsc-group="' + escapeHtml(key) + '"' + (index < 5 ? ' open' : '') + '>';
        html += '<summary>' + escapeHtml(FACET_LABELS[key] || key) + ' <span aria-hidden="true">-</span></summary><div>';
        options.forEach(function (option) {
          html += '<label class="gsc-filter-option"><input type="checkbox" value="' + escapeHtml(option) + '" data-gsc-option="' + escapeHtml(key) + '">';
          html += '<span>' + escapeHtml(option) + '</span><small data-gsc-option-count>' + cards.filter(function (card) { return cardValues(card, key).indexOf(option) > -1; }).length + '</small></label>';
        });
        html += '</div></details>';
      });
      facetGroups.innerHTML = html;
    }

    function readSelected() {
      selected = {};
      root.querySelectorAll('[data-gsc-option]:checked').forEach(function (input) {
        var key = input.getAttribute('data-gsc-option');
        if (!selected[key]) selected[key] = [];
        selected[key].push(input.value);
      });
      priceMin = priceMinInput ? priceMinInput.value.trim() : '';
      priceMax = priceMaxInput ? priceMaxInput.value.trim() : '';
    }

    function matches(card, ignoredKey) {
      var query = search ? search.value.trim().toLowerCase() : '';
      if (query && (card.getAttribute('data-search') || '').indexOf(query) === -1) return false;
      var cardPrice = Number(card.getAttribute('data-price') || 0);
      if (priceMin && cardPrice < Number(priceMin) * 100) return false;
      if (priceMax && cardPrice > Number(priceMax) * 100) return false;
      return Object.keys(selected).every(function (key) {
        if (key === ignoredKey || !selected[key].length) return true;
        var values = cardValues(card, key);
        return selected[key].some(function (value) { return values.indexOf(value) > -1; });
      });
    }

    function updateOptionCounts() {
      root.querySelectorAll('[data-gsc-option]').forEach(function (input) {
        var key = input.getAttribute('data-gsc-option');
        var count = cards.filter(function (card) {
          return matches(card, key) && cardValues(card, key).indexOf(input.value) > -1;
        }).length;
        var countNode = input.parentNode.querySelector('[data-gsc-option-count]');
        if (countNode) countNode.textContent = count;
        input.disabled = count === 0 && !input.checked;
      });
    }

    function syncUrl() {
      if (!window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      Array.from(url.searchParams.keys()).forEach(function (key) {
        if (key.indexOf('gsc_') === 0) url.searchParams.delete(key);
      });
      if (search && search.value.trim()) url.searchParams.set('gsc_q', search.value.trim());
      Object.keys(selected).forEach(function (key) {
        if (selected[key].length) url.searchParams.set('gsc_' + key, selected[key].join('~'));
      });
      if (priceMin) url.searchParams.set('gsc_price_min', priceMin);
      if (priceMax) url.searchParams.set('gsc_price_max', priceMax);
      window.history.replaceState({}, '', url.toString());
    }

    function applyFilters(updateUrl) {
      readSelected();
      var visible = 0;
      cards.forEach(function (card) {
        var match = matches(card, '');
        card.hidden = !match;
        if (match) visible += 1;
      });
      if (empty) empty.hidden = visible !== 0;
      if (visibleCount) visibleCount.textContent = visible + (visible === 1 ? ' product family' : ' product families');
      if (headingCount) headingCount.textContent = visible;
      updateOptionCounts();
      if (updateUrl) syncUrl();
    }

    function restoreUrlState() {
      var params = new URL(window.location.href).searchParams;
      if (search && params.get('gsc_q')) search.value = params.get('gsc_q');
      root.querySelectorAll('[data-gsc-option]').forEach(function (input) {
        var values = (params.get('gsc_' + input.getAttribute('data-gsc-option')) || '').split('~');
        input.checked = values.indexOf(input.value) > -1;
      });
      if (priceMinInput) priceMinInput.value = params.get('gsc_price_min') || '';
      if (priceMaxInput) priceMaxInput.value = params.get('gsc_price_max') || '';
    }

    renderFacets();
    restoreUrlState();
    applyFilters(false);

    if (search) search.addEventListener('input', function () { applyFilters(true); });
    if (facetGroups) facetGroups.addEventListener('change', function (event) {
      if (event.target.matches('[data-gsc-option]')) applyFilters(true);
    });
    if (priceApply) priceApply.addEventListener('click', function () { applyFilters(true); });
    if (clearButton) clearButton.addEventListener('click', function () {
      if (search) search.value = '';
      root.querySelectorAll('[data-gsc-option]').forEach(function (input) { input.checked = false; });
      if (priceMinInput) priceMinInput.value = '';
      if (priceMaxInput) priceMaxInput.value = '';
      applyFilters(true);
    });

    var prices = cards.map(function (card) { return Number(card.getAttribute('data-price') || 0); }).filter(Boolean);
    if (priceGroup && prices.length && Math.min.apply(Math, prices) === Math.max.apply(Math, prices)) priceGroup.hidden = true;

    var mobileSort = root.querySelector('[data-gsc-sort-mobile]');
    if (mobileSort) {
      mobileSort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', mobileSort.value);
        window.location.assign(url.toString());
      });
    }
    root.querySelectorAll('[data-gsc-diagram]').forEach(drawCategoryDiagram);
  }

  document.querySelectorAll('.gsc-collection').forEach(init);
})();
